import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { TRANSLATION_NS } from '@contact/upgrade';

@NgModule({})
export class LoginForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: LoginForRootModule) {
    if (parentModule) throw new Error(`[LoginForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<LoginForRootModule> {
    return {
      ngModule: LoginForRootModule,
      providers: [
        {
          provide: TRANSLATION_NS,
          useValue: 'login',
          multi: true,
        },
      ],
    };
  }
}
